import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { STATES } from 'common/domain/states';
import { ROUTES } from 'common/domain/routes';
import requestCardSimulationFamilyComponent from './requestCardSimulationFamily.component';
import cardSimulationMoreInfo from './cardSimulationMoreInfo/cardSimulationMoreInfo';

let requestCardSimulationFamilyModule = angular.module('requestCardSimulationFamily', [
  uiRouter,
  cardSimulationMoreInfo
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state(STATES.LOANS.NEED_A_LOAN_RESULTS, {
      url: ROUTES.LOANS.NEED_A_LOAN_RESULTS,
      component: 'requestCardSimulationFamily',
      params: {
        snapshot: null,
      },
      data: {
        requiresAuth: true,
      }
    });
})

.component('requestCardSimulationFamily', requestCardSimulationFamilyComponent)

.name;

export default requestCardSimulationFamilyModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/requestCardSimulationFamily/requestCardSimulationFamily.js